import axios from 'axios'
import { get } from 'lodash'

import { getConfig } from '../../utils'

import { FAQS_FAILURE, FAQS_REQUEST, FAQS_SUCCESS } from './type'

export const getFaqs =
  (locale, limit = 0) =>
  async (dispatch) => {
    if (locale) {
      try {
        const lang = locale === 'cn' ? 'zh-CN' : locale
        dispatch({ type: FAQS_REQUEST })
        const resFaqs = await axios.get(
          `${getConfig('HOST_API')}/faqs?_locale=${lang}&_limit=${limit}`,
        )
        const payload = get(resFaqs, 'data', [])
        dispatch({ type: FAQS_SUCCESS, payload })
      } catch (err) {
        dispatch({ type: FAQS_FAILURE, payload: err.message })
      }
    }
  }
